import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress errors from external scripts (like browser extensions)
window.addEventListener('error', (event) => {
  // Ignore errors from share-modal.js (likely from browser extension)
  if (event.filename && event.filename.includes('share-modal.js')) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
  // Ignore errors from null elements (browser extensions trying to access DOM)
  if (event.message && event.message.includes('Cannot read properties of null')) {
    const isFromExtension = event.filename && (
      event.filename.includes('extension://') ||
      event.filename.includes('share-modal') ||
      event.filename.includes('chrome-extension://') ||
      event.filename.includes('evmAsk') ||
      event.filename.includes('phantom')
    );
    if (isFromExtension || !event.filename) {
      // Suppress if from extension or if filename is not available (likely extension)
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }
}, true);

// Suppress unhandled promise rejections from extensions
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && typeof event.reason === 'object') {
    const stack = event.reason.stack || '';
    if (stack.includes('share-modal') || stack.includes('extension://') || stack.includes('evmAsk') || stack.includes('phantom')) {
      event.preventDefault();
      return false;
    }
  }
  // Also check the error message
  if (event.reason && typeof event.reason === 'string') {
    if (event.reason.includes('share-modal') || event.reason.includes('evmAsk') || event.reason.includes('phantom')) {
      event.preventDefault();
      return false;
    }
  }
});

// Block local network access requests (browser extensions or Chrome features)
if (navigator.permissions) {
  navigator.permissions.query({ name: 'local-network' }).catch(() => {
    // Silently ignore - not all browsers support this
  });
}

// Prevent any code from requesting local network access
const originalQuery = navigator.permissions?.query;
if (originalQuery) {
  navigator.permissions.query = function(descriptor) {
    if (descriptor?.name === 'local-network') {
      return Promise.reject(new DOMException('Local network access blocked', 'NotAllowedError'));
    }
    return originalQuery.call(this, descriptor);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

